import React from 'react';
import { Button, Form } from 'antd';
import TextInput from '../inputs/TextInput';
import SelectInput from '../inputs/SelectInput';
import PasswordInput from '../inputs/PasswordInput';
import useTranslation from '../../hooks/translation/useTranslation';

function PhysicalCustomerForm({
  form, options, loading, onFinish,
}) {
  const { trans } = useTranslation();
  const citizenship = Form.useWatch('citizenship', form);
  const isGeorgian = options?.countries?.find((country) => country.id === citizenship)?.name_ka === 'საქართველო';

  return (
    <Form
      layout="vertical"
      form={form}
      onFinish={onFinish}
      onValuesChange={(changedValues) => {
        form.setFields(Object.keys(changedValues).map((key) => ({
          name: key,
          errors: [],
        })));
      }}
    >
      <TextInput
        label={`${trans('name')}*`}
        name="first_name"
      />
      <TextInput
        label={`${trans('last_name')}*`}
        name="last_name"
      />
      <SelectInput
        name="gender"
        label={`${trans('gender')}*`}
        options={options?.genders?.map(
          (gender) => ({
            ...gender,
            label: trans(gender.label),
          }),
        )}
        labelName="label"
        valueName="value"
      />
      <SelectInput
        name="citizenship"
        label={`${trans('citizenship')}*`}
        options={options?.countries}
        labelName="name_ka"
        valueName="id"
      />
      <TextInput
        label={`${trans(isGeorgian ? 'personal_number' : 'passport_number')}*`}
        name={isGeorgian ? 'personal_number' : 'passport_number'}
      />
      <SelectInput
        name="country_phone_code"
        label={`${trans('country_phone_code')}*`}
        options={options?.countries}
        labelName="country_phone_code"
        valueName="id"
      />
      <TextInput
        label={`${trans('phone_number')}*`}
        name="phone_number"
      />
      <TextInput
        label={`${trans('email')}*`}
        name="email"
      />
      <PasswordInput
        label={`${trans('password')}*`}
        name="password"
      />
      <Form.Item>
        <Button type="primary" htmlType="submit" loading={loading}>
          {trans('submit')}
        </Button>
      </Form.Item>
    </Form>
  );
}

export default PhysicalCustomerForm;
